const Actions = ({ label, actions, variant = "outlined", body }) => {
  return (
    <div
      className={`actions__mobilityMutual ${variant ? `actions__mobilityMutual--${variant}` : ""}`}
    >
      <div className="actions__mobilityMutual--head">
        <div className="actions__mobilityMutual--left">
          <span dangerouslySetInnerHTML={{ __html: label }}></span>
        </div>
        <div className="actions__mobilityMutual--right">
          <div className="d-flex">{actions}</div>
        </div>
      </div>
      {body && <div className="actions__mobilityMutual--body"> {body} </div>}
    </div>
  );
};

export default Actions;
